module.exports = __webpack_public_path__ + "static/img/shiji payment logo.dfe58cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shiji payment logo.png
// module id = QZTR
// module chunks = 12